import {bootstrapApplication} from '@angular/platform-browser';
import {provideAnimations} from '@angular/platform-browser/animations';
import {appConfig} from './app/app.config';
import {AppComponent} from './app/app.component';
import {initializeTheme} from './theme-initializer';

const loader = document.getElementById('app-loader');
if (loader) {
  loader.style.display = 'flex';
}

initializeTheme()().then(() => {
  bootstrapApplication(AppComponent, {
    ...appConfig,
    providers: [
      ...(appConfig.providers || []),
      provideAnimations(),
    ],
  }).then(() => {

  }).catch(err => console.error(err));
});
